import React from "react";
import { Box, Button, Typography, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Renders the collapsible ticket history used inside RowTableEstadia.
 *
 * props:
 *  - tickets (array)
 *  - mostrarIngreso (bool)
 *  - item (object) // used for placa and counts
 *  - onToggle (fn) toggles mostrarIngreso
 *  - onAnular (ticket) sets the ticket to annul
 *  - onPrint (ticketId) opens PDF
 *  - openAnular (bool)
 *  - setOpenAnular (fn)
 */
const TicketHistoryTable = ({
  tickets,
  mostrarIngreso,
  item,
  onToggle,
  onAnular,
  onPrint,
  openAnular,
  setOpenAnular,
}) => {
  return (
    <Box sx={{ margin: 1 }}>
      <Typography sx={{ fontWeight: 'bold' }}>
        Tickets de {mostrarIngreso ? 'Ingresos' : 'Salidas'}: {mostrarIngreso ? item.ticketsIngreso.length : item.ticketsEgreso.length}
        <Button onClick={onToggle}>
          {mostrarIngreso ? 'Ver Salidas' : 'Ver Ingresos'}
        </Button>
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Placa</TableCell>
            {mostrarIngreso ? (
              <>
                <TableCell sx={{ fontWeight: 'bold' }}>Fecha de Ingreso</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Hora de Ingreso</TableCell>
              </>
            ) : (
              <>
                <TableCell sx={{ fontWeight: 'bold' }}>Fecha de Salida</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Hora de Salida</TableCell>
              </>
            )}
            <TableCell sx={{ fontWeight: 'bold' }}>Usuario</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Cliente</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Observaciones</TableCell>
            {!mostrarIngreso && (
              <>
                <TableCell sx={{ fontWeight: 'bold' }}>Valor a Pagar</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Tiempo transcurrido</TableCell>
              </>
            )}
            <TableCell sx={{ fontWeight: 'bold' }}>Fecha-Hora de Creación</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Estado</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tickets.map((ticket) => (
            <TableRow key={ticket.id}>
              <TableCell>{ticket.id}</TableCell>
              <TableCell>{ticket.placa_vehiculo || '—'}</TableCell>
              {mostrarIngreso ? (
                <>
                  <TableCell>{ticket.fecha_ingreso}</TableCell>
                  <TableCell>{ticket.hora_ingreso}</TableCell>
                </>
              ) : (
                <>
                  <TableCell>{ticket.fecha_salida}</TableCell>
                  <TableCell>{ticket.hora_salida}</TableCell>
                </>
              )}
              <TableCell>{ticket.nombre_usuario}</TableCell>
              <TableCell>{ticket.nombre_cliente}</TableCell>
              <TableCell>{ticket.observaciones}</TableCell>
              {!mostrarIngreso && (
                <>
                  <TableCell>{ticket.valor_a_pagar}</TableCell>
                  <TableCell>{ticket.tiempo_transcurrido}</TableCell>
                </>
              )}
              <TableCell>
                {ticket.fecha_hora_creacion
                  ? ticket.fecha_hora_creacion.replace(' ', ' | ')
                  : 'Fecha desconocida'}
              </TableCell>
              <TableCell>{!ticket.anulado ? ticket.estado : 'ANULADO'}</TableCell>
              <TableCell>
                <IconButton
                  color="error"
                  onClick={() => { onAnular(ticket); setOpenAnular(true); }}
                  disabled={ticket.anulado}
                >
                  <CancelIcon />
                </IconButton>
                <IconButton onClick={() => onPrint(ticket.id)}>
                  <PrintIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/* confirmation dialog moved outside in parent because we need state */}
    </Box>
  );
};

export default TicketHistoryTable;
